// extracted by mini-css-extract-plugin
export default {"mobileFunds":"ReportsPage_mobileFunds__1tesk","desktopFundReports":"ReportsPage_desktopFundReports__EwCF5"};